export const IMS_SCOPE_PARAMS_SUSI_LOGIN =
  'openid,avatar,read_organizations,additional_info.job_function,session,additional_info.projectedProductContext,additional_info.account_type,additional_info.roles,additional_info.user_image_url,audiencemanager_api';
export const EXPIRY_TIME = 3600000;
export const ACCESS_TOKEN_REGEX = /access_token=([^&#]+)/;
export const PARAM_HINT_TENANT_ID = 'hintTenantId';
export const PARAM_RESOURCE = 'resource';
export const PARAM_PREFIX_TENANT_ID = 'prefixtenantid';
export const PARAM_REDIRECT_LOCATION = 'redirectlocation';
export const PARAM_LOGINAS = 'loginas';
export const PARAM_EXC_LOGINIMS = 'exc-loginims';
export const IMS_TOU_ERROR = 'ride_AdobeID_acct_terms';



// WEBPACK FOOTER //
// ./src/components/ExpLogin/constants/loginConstants.js